import React, {Component} from 'react';
import { Field } from 'formik';
import { isFieldValidClass } from "~/js/utils";

class Textarea extends Component {
    render() {
        const { name, form, ...rest } = this.props;

        return (
            <div className={`textarea ${form ? isFieldValidClass(name, form): ''}`}>
                <Field 
                    name={name}
                    component="textarea"
                    className={`textarea__textarea`} 
                    {...rest}
                />
            </div>
        );
    }
}

export { Textarea };